import DataLoader from 'dataloader'

export const createDataLoader = loadFn => new DataLoader(loadFn)
